import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { SectionHeading } from './SectionHeading';
import { tomos, tomoIncludes } from '../data/content';
export function TomosSection() {
  return <section className="w-full bg-ink-950 py-20" aria-labelledby="tomos-title" data-id="element-243" data-mp="1p4vb90bqc2z8">
      <div className="mx-auto max-w-6xl px-5" data-id="element-244" data-mp="1u1ln1bgi4ceu">
        <SectionHeading eyebrow="MegaPack Reto 30 días fit" title={<span id="tomos-title" data-id="element-246" data-mp="xdyys0tl00ch">6 Tomos + 3 Bonos</span>} subtitle={<>
              Detox → Entrenamiento → Nutrición → Mentalidad.{' '}
              <span className="font-semibold text-gold-400" data-id="element-247" data-mp="16csy3yyar4tq">300+ páginas</span> — todo resuelto.
            </>} data-id="element-245" data-mp="1u4hlr206b54c" />

        <div className="mt-8 flex flex-wrap justify-center gap-2" data-id="element-248" data-mp="1bdqfwafe9wup">
          {['Detox', 'Gym', 'Casa', 'Ayuno', 'Nutrición', 'Batch Cooking'].map(t => <span key={t} className="rounded-full border border-cream/12 bg-cream/5 px-3.5 py-1.5 text-xs font-semibold uppercase tracking-wide text-cream/70" data-id="element-249" data-mp="2mqsvb25rcgda">
              {t}
            </span>)}
        </div>

        <ul className="mt-14 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-250" data-mp="2mksq0v40i69n">
          {tomos.map((tomo, i) => <motion.li key={tomo.number} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.45,
          delay: Math.min(i * 0.06, 0.3),
          ease: 'easeOut'
        }} className="group relative flex flex-col gap-3 overflow-hidden rounded-2xl border border-cream/10 bg-ink-800 p-6 transition-colors duration-200 hover:border-gold-500/40" data-id="element-251" data-mp="2cofyo3vxw4i2" data-mpi={i}>
              <span aria-hidden="true" className="absolute -right-4 -top-6 font-display text-7xl text-cream/[0.04]" data-id="element-252" data-mp="1oyvclc4hor4k">
                {i + 1}
              </span>
              <div className="flex items-center gap-2" data-id="element-253" data-mp="1acfvocsyditu">
                <span className="rounded-md bg-gold-500 px-2 py-0.5 font-display text-[11px] uppercase tracking-wider text-ink-950" data-id="element-254" data-mp="1aauzyjuwjtue">
                  {tomo.number}
                </span>
                <span className="text-[11px] font-semibold uppercase tracking-wide text-rose-400" data-id="element-255" data-mp="11d2jvdhcwi5y">
                  {tomo.tag}
                </span>
              </div>
              <h3 className="font-display text-xl uppercase leading-tight text-cream" data-id="element-256" data-mp="1t2e1snd6x1uu">
                {tomo.title}
              </h3>
              <p className="text-sm leading-relaxed text-cream/65" data-id="element-257" data-mp="1y18x2oscgivu">{tomo.text}</p>
            </motion.li>)}
        </ul>

        <div className="mt-12 rounded-3xl border border-cream/10 bg-ink-900 p-7 sm:p-9" data-id="element-258" data-mp="1k8j583q4wjqt">
          <h3 className="font-display text-lg uppercase tracking-wide text-gold-500" data-id="element-259" data-mp="1o9urq0dpoous">
            Cada tomo incluye:
          </h3>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2" data-id="element-260" data-mp="2gsrxqoywbkup">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-3 text-sm text-cream/80" data-id="element-261" data-mp="5crc0hw6wx37">
                <span className="mt-0.5 flex h-5 w-5 shrink-0 items-center justify-center rounded-full bg-gold-500/15" data-id="element-262" data-mp="eg2k89t4oli">
                  <CheckIcon className="h-3 w-3 text-gold-500" aria-hidden="true" data-id="element-263" data-mp="f3cb06fs03mn" />
                </span>
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}